module.exports = __webpack_public_path__ + "static/media/Agenda5.da7614f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda5.png
// module id = 1970
// module chunks = 0